<template>
  <template-card
    :name="name"
    preview-width="110px"
    preview-height="100px"
    icon="mdi-image"
    @dragend:item="addItemDrop()"
    @click:item="addItem()" />
</template>
<script>
import paperBuilderToolMixin from '@/mixins/paperBuilderToolMixin'
import { v4 as uuid } from 'uuid'
import TemplateCard from './TemplateCard.vue'

export default {
  components: { TemplateCard },
  mixins: [
    paperBuilderToolMixin
  ],
  methods: {
    addItem () {
      const { left, top } = this.paperBuilderDrop || { left: '20px', top: '20px' }
      this.addPaperBuilderCanvas({
        id: this.paperBuilderId,
        data: {
          id: uuid(),
          type: 'image',
          tag: 'div',
          fx: {},
          properties: {
            style: {
              position: 'absolute',
              left,
              top,
              width: '110px',
              height: '100px',
              fontSize: '14px',
              overflow: 'hidden',
              backgroundSize: 'contain',
              backgroundPosition: 'center center',
              backgroundRepeat: 'no-repeat',
              backgroundImage: null
            }
          },
          children: []
        }
      })
    }
  }
}
</script>
<style scoped>

</style>
